import * as React from 'react';
import { Body1, Link } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';

import { IRoomStatsCellValue } from '../../../../../../types/newbuildingsCompare';
import { getNewbuildingIdFromUrl } from '../shared/getNewbuildingIdFromUrl';
import { trackNavigationToListingJK } from '../shared/tracking';
import * as style from './style.css';

export interface IRoomStatsCellDesktopProps {
  data: IRoomStatsCellValue;
}

export const RoomStatsCellDesktop = ({ data }: IRoomStatsCellDesktopProps): React.JSX.Element => {
  const handleLinkClick = React.useCallback(() => {
    trackNavigationToListingJK(getNewbuildingIdFromUrl(data.roomLink.url));
  }, [data]);

  return (
    <div className={style['container']}>
      {data.priceRange && <Body1>{data.priceRange}</Body1>}
      {data.minArea && <Body1 color="text-secondary-default">{data.minArea}</Body1>}
      <Link
        href={data.roomLink.url}
        target="_blank"
        fontSize="M"
        fontWeight="bold"
        onClick={handleLinkClick}
        afterIcon={<IconActionChevronRightSmall16 color="icon-main-default" />}
      >
        {data.roomLink.text}
      </Link>
    </div>
  );
};
